module.exports = __webpack_public_path__ + "media/assets/images/blog/TESTA-LINKEDIN-3-e13f4145eeb250ab8ba6702f989db88c.jpg";